import { useState } from "react";
import { Button, Icons } from "@/components/ui";
import { MarkdownContent } from "@/components/ui/markdown-content";
import { useT } from "@/i18n";
import { toastsMessages } from "@/i18n/messages/toasts";
import { resultDetailLine } from "@/lib/work-toast-result-summary";

/** Historical text stays available without competing with current activity. */
export function WorkToastTextPreview({
  text,
  compact = false,
}: {
  text: string;
  compact?: boolean;
}) {
  const t = useT(toastsMessages);
  const [expanded, setExpanded] = useState(false);
  const label = expanded ? t("collapse") : t("expand");
  return (
    <>
      {compact && (
        <Button
          variant="ghost"
          size="sm"
          className="h-auto w-full min-w-0 justify-start gap-1 p-0 text-left text-inherit"
          aria-label={label}
          aria-expanded={expanded}
          title={label}
          onClick={() => setExpanded((value) => !value)}
          data-testid="work-toast-text-toggle"
          data-interactive="true"
        >
          <span className="min-w-0 flex-1 truncate">
            {resultDetailLine(text)}
          </span>
          {expanded ? (
            <Icons.ChevronUp className="h-3 w-3 shrink-0" />
          ) : (
            <Icons.ChevronDown className="h-3 w-3 shrink-0" />
          )}
        </Button>
      )}
      {(!compact || expanded) && (
        <MarkdownContent
          content={text}
          className="[&_li]:leading-snug [&_p]:leading-snug"
        />
      )}
    </>
  );
}
